export default "__VITE_ASSET__CxUTUGCg__"